import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Folder from './icon-empty-folder.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Folder {...validProps} />;
}
SvgComponent.iconName = 'emptyFolder';

/**
 * @deprecated This is a legacy icon
 */
export const EmptyFolderIcon = svgIconWrapper(SvgComponent);
